import { create } from 'zustand';

interface TooltipState {
  text: string | null;
  show: (text: string) => void;
  hide: () => void;
}

export const useTooltipStore = create<TooltipState>()((set) => ({
  text: null,
  show: (text) => set({ text }),
  hide: () => set({ text: null }),
}));
